export default {
  List: {
    BURegularExpenses: 'Kinh phí thường xuyên',
    BUInvestmentCost: 'Kinh phí đầu tư',
    RejectFileTitle: 'Từ chối duyệt hồ sơ giao dịch',
    RejectFileTitleShort: 'Từ chối duyệt hồ sơ',
    AcceptFileTitleShort: 'Duyệt hồ sơ',
    QuestionRejectOneFile: 'Bạn có thực sự muốn từ chối duyệt hồ sơ giao dịch với KBNN {0} không?',
    QuestionRejectMultiFiles: 'Bạn có thực sự muốn từ chối duyệt các hồ sơ giao dịch với KBNN đã chọn không?',

    MainTitle: 'Hồ sơ giao dịch với KBNN',
    CheckFileStatus: 'Kiểm tra trạng thái hồ sơ từ KBNN',
    EventReject: 'Từ chối duyệt',
    DebitVoucherDownload: 'Tải chứng từ báo Nợ',
    QHNS: 'Mã QHNS',
    TransferUnit: 'Chuyển đơn vị',
    ChooseAttachFile: 'Chọn hồ sơ liên kết',
    UploadDocumentFile: 'Tải tệp đính kèm',
  },

  Detail: {
    InvalidFileAttach: 'Tệp đính kèm không hợp lệ',
    FileCode: 'Mã hồ sơ',
    RefreshFileCode: 'Làm mới mã hồ sơ',
    FileDetailSetting: 'Thiết lập quy tắc sinh Mã hồ sơ',
    StateTreasuryName: 'Giao dịch tại',
    Account: 'Tài khoản',
    SentDate: 'Ngày tạo',
    TitleFile: 'Tiêu đề hồ sơ',
    TemplateVoucherFile: 'Mẫu chứng từ giao dịch với kho bạc',
    AddTemplateVoucher: 'Chọn mẫu chứng từ',
    DownloadVoucher: 'Tải chứng từ báo nợ',
    RestorePrint: 'In phục hồi',
    AttachReceiveFile: 'Đính kèm tài liệu nhận',
    UploadAttachFile: 'Tải lên tệp đính kèm',
    RequireFile_1: 'Hỗ trợ tệp định dạng ',
    RequireFile_2: 'PDF',
    RequireFile_3: ', tổng dung lượng các tệp tối đa ',
    RequireFile_4: '4MB',
    NoteFilePlaceholder: 'Nhập thông tin ghi chú của tài liệu',
    ChooseMajor: 'Chọn nghiệp vụ',
    MajorName: 'Nghiệp vụ  ',
    MajorCode: 'Mã nghiệp vụ  ',
    Description: 'Diễn giải ',
    ApprovalOfficer: 'Cán bộ phê duyệt',
    QHNS: 'Mã QHNS giao dịch',
  },

  SettingDVCFilePopup: {
    Title: 'Thiết lập mã hồ sơ',
    AdviseSentence:
      'Nếu có nhiều dữ liệu kế toán cùng năm hạch toán, đơn vị nên thiết lập hậu tố khác nhau cho các dữ liệu này để không bị trùng mã hồ sơ khi nộp lên KBNN.',
    LabelFileCode: 'Thiết lập lại mã hồ sơ giao dịch',
    Prefix: 'Tiền tố',
    Suffix: 'Hậu tố',
    IncrementNumber: 'Số tự tăng',
    Preview: 'Xem trước',
    LabelRefNo: 'Thiết lập lại số chứng từ kho bạc',
  },
  DVCTreasuryCashWithdraw: {
    At: 'Tại',
    Title: 'Rút dự toán tiền mặt',
    PaymentOff: 'Thực chi',
    PaymentTU: 'Tạm ứng',
    PaymentTUTH: 'Tạm ứng thu hồi',
    AdvanceToSpent: 'Tạm ứng sang thực chi',
    AdvanceUnPay: 'Ứng trước chưa đủ điều kiện thanh toán',
    AdvancePay: 'Ứng trước đủ điều kiện thanh toán',
    NoConditionToCondition: 'Ứng trước chưa đủ ĐKTT sang ứng trước đủ ĐKTT',
    AdvanceWithEnoughPayments: 'Ứng trước đủ điều kiện thanh toán',
    AdvanceWithNoEnoughPayments: 'Ứng trước chưa đủ điều kiện thanh toán',
    Tranfer: 'Chuyển khoản',
    CashKB: 'Tiền mặt tại KB',
    CashNH: 'Tiền mặt tại NH',
    RecievingUnit: 'Đơn vị hưởng',
    ProjectCode: 'Mã CTMT, DA',
    ProjectName: 'Tên CTMT,DA',
    TenDuAn: 'Tên dự án',
    ProjectCodeCustom: 'Mã ĐVQHNS/ DA',
    HĐKNo: 'Số CKC, HĐK',
    HĐThNo: 'Số CKC, HĐTH',
    NSYear: 'Năm NS',
    BudgetYear: 'Năm ngân sách',
    RefNo: 'Số chứng từ giấy',
    Description: 'Diễn giải',
    Reciever: 'Người nhận',
    IdentityNumber: 'Số CMND',
    IssueDate: 'Cấp ngày',
    IssueBy: 'Nơi cấp',
    Name: 'Họ tên',
    Tax: 'Nộp thuế',
    Detail: 'Chi tiết',
    BtnViewVoucher: 'Chọn chứng từ',
    ViewVoucher: 'Xem mẫu chứng từ',
    UnitName: 'Tên đơn vị',
    TaxCode: 'Mã số thuế',
    NDKTCode: 'NDKT',
    ChapterCode: 'Mã chương',
    TaxPeroid: 'Kỳ thuế',
    CQ: 'CQ quản lý thu',
    KBNN: 'KBNN hạch toán khoản thu',
    Quantity: 'Số lượng',
    BankAccountTrea: 'TKKB',
    BankPlace: 'Tại kho bạc',
    DVNhan: 'Đơn vị nhận',
    DVNhanTen: 'Tên đơn vị nhận',
    TK: 'Tài khoản',
    TKNH: 'Tại KBNN (NH)',
    Adress: 'Địa chỉ',
    TKNhan: 'Tài khoản nhận',
    BankName: 'Tên ngân hàng',
    ChooseVoucherPosted: 'Chọn CT hạch toán',
    OpenPlace: 'Mở tại',
    NHKBCode: 'Mã ngân hàng, KB',
    SponsorCode: 'Mã tài trợ',
    PayAdvancePayment: 'Nộp trả - Tạm ứng',
    PayDicrect: 'Nộp trả - Thực chi',
    Restore: 'Khôi phục',
    Cash: 'Tiền mặt',
    StateTreasury: 'Đề nghị KBNN',
    Account: 'Trích Tài khoản',
    Payer: 'Người nộp tiền',
    DecisionNo: 'Theo Quyết định số',
    Date: 'Ngày',
    Investor: 'Đơn vị rút dự toán/Chủ đầu tư',
    UnitName: 'Tên đơn vị',
    UnitCode: 'Mã đơn vị',
    BudgetCode: 'Mã QHNS',
    PaymentUnit: 'Đơn vị nộp',
    DeclarationNo: 'Số Tờ khai/Quyết định/Thông báo',
    DeclarationDate: 'Kỳ thuế/Ngày tờ khai/Quyết định/Thông báo',
    BudgetSourceProperty: 'Tính chất nguồn',
    BankAccount: 'Tài khoản kho bạc',
    InvestorAccountNumber: 'Số tài khoản của chủ đầu tư',
    DomesticCapital: 'Vốn trong nước',
    ForeignCapital: 'Vốn ngoài nước',
    RequestInvestPaymentNo: 'Căn cứ giấy đề nghị thanh toán vốn đầu tư số',
    Contract: 'Hợp đồng',
    ContractNo: 'Căn cứ HĐ số',
    ContractAddendumNo: 'Phụ lục bổ sung HĐ số',
    DecisionNumber: 'Căn cứ quyết định phê duyệt dự án số',
    ContractAmountNo: 'Căn cứ bảng quyết định giá trị KLHT đề nghị thanh toán số',
    AccumulatedVolume: 'Lũy kế giá trị khối lượng nghiệm thu của hạng mục đề nghị thanh toán',
    AdvanceBalance: 'Số dư tạm ứng của hạng mục đề nghị thanh toán',
    CapitalSource: 'Thuộc nguồn vốn',
    SuggestionPlan: 'Thuộc KHV',
    CapitalPlanYear: 'Năm KHV',
    PaymentToUnit: 'Thanh toán cho đơn vị hưởng',
    BtnChooseVoucher: 'Chọn phiếu chi',
    InvestorCode: 'Mã Chủ đầu tư',
    InvestorName: 'Tên Chủ đầu tư',
    InvestorQHNS: 'Mã QHNS của Chủ đầu tư',
    Default: 'Mặc định',
    Dynamic: 'Mẫu tùy chỉnh',
    VerticalDynamic: 'Mẫu dọc - tùy chỉnh',
  },

  Title: {
    MappingVoucher: 'Cập nhật Sinh hạch toán',
    MappingInvoice: 'Cập nhật hóa đơn liên kết',
    SubmitFail: 'Cất không thành công',
    ChooseVoucherFail: 'Thanh toán không thành công',
  },
  Message: {
    AccountWarning: 'Cần nhập mã ngân hàng, kho bạc để nộp lên DVC.',
    TitleAccountWarning: 'Nhập Mã ngân hàng, kho bạc',
    CheckAccount: `Tài khoản mở tại Kho bạc của đơn vị hưởng phải đúng định dạng &lt;Mã TKTN&gt;.&lt;Mã cấp NS&gt.&lt;Mã QHNS&gt để nộp lên DVC. Vui lòng kiểm tra lại.`,
    TitleCheckAccount: 'Tài khoản của đơn vị hưởng chưa đúng định dạng',
    CheckAccountTreasury: 'Tài khoản Kho bạc rút chưa đăng ký với Kho bạc, vui lòng chọn tài khoản khác.',
    TitleCheckAccountTreasury: 'Số Tài khoản kho bạc không hợp lệ',
    TitleRequiredTax: 'Thiếu thông tin nộp thuế',
    RequiredTax: 'Yêu cầu nhập đủ thông tin nộp thuế.',
    AccountError: 'Số tài khoản kho bạc không hợp lệ',
    Invalid: 'Không hợp lệ',
    InvalidInformationTitle: 'Thông tin không hợp lệ',
    BankAccountInValid: 'Tài khoản sai định dạng',
    BankAccountNotExist: 'TKKB chưa đăng ký với kho bạc',
    InvalidMappingCommercialBank:
      'Tên ngân hàng thanh toán cho đối tượng thụ hưởng không hợp lệ, bạn cần chuẩn hóa trước khi cất hồ sơ.',
    InvalidEmptyCommercialBank: 'Thiếu tên ngân hàng chuẩn hóa theo KBNN. Vui lòng kiểm tra lại.',
    InvalidEmptyDocument: 'Thông tin tài liệu của tệp đính kèm không được để trống.',
    MappingVoucher:
      'Hồ sơ kho bạc điện tử <b>{0}</b> đã sinh hạch toán <b>{1}</b>, bạn có muốn cập nhật hạch toán sang hồ sơ <b>{2}</b> không?',
    MappingInvoice:
      'Hồ sơ kho bạc điện tử <b>{0}</b> đang có liên kết đến hóa đơn <b>{1}</b>. Bạn có muốn chuyển liên kết với các hóa đơn này sang hồ sơ mới <b>{2}</b> không?',
    CheckChooseCashWithDraw: 'Chưa chọn nghiệp vụ. Vui lòng kiểm tra lại.',
    ChooseVoucherMsg: 'Bạn phải chọn ít nhất 1 chứng từ',
    CopyDvcFile:
      'Hồ sơ này đã được thực hiện sửa thành hồ sơ {0} nên không thể thực hiện sửa tiếp. Vui lòng kiểm tra lại.',
  },
  // text cho màn giới thiệu dvc
  IntroductionDvc: {
    Description: 'Trước khi sử dụng cần kiểm tra những thông tin sau. Xem hướng dẫn',
    StartUsingDvc: 'Bắt đầu sử dụng Kho bạc điện tử',
    Step1: 'Khai báo Tài khoản kho bạc đã đăng ký giao dịch với DVC',
    ButtonStep1: 'Khai báo Tài khoản kho bạc',
    Step2: 'Khai báo Tính chất nguồn để giao dịch với DVC',
    ButtonStep2: 'Khai báo Tính chất nguồn',
  },

  AdvancePayment: {
    BankAccountTreasury: 'Số tài khoản giao dịch với Kho bạc',
  },
  StandardizeDvcBudgetSource: {
    Description: 'Cần bổ sung tính chất nguồn để nộp cho DVC. Vui lòng chọn Tính chất nguồn.',
    Title: 'Bổ sung tính chất nguồn',
    BtnText: 'Bổ sung',
  },
  DvcTransferUnit: {
    Title: 'Chuyển đơn vị giao dịch với KBNN',
  },
  ChooseVoucherDvcPosted: {
    Notify: {
      Message:
        'Ngày hạch toán của các chứng từ đã chọn phải nhỏ hơn ngày tạo hồ sơ kho bạc điện tử. Vui lòng kiểm tra lại.',
      TextButton: 'Đồng ý',
      Title: 'Không hợp lệ',
    },
  },
  UnpostedVoucherNoti: {
    FirstMessage:
      'Chứng từ đã được chọn lên hồ sơ KBĐT <span class="color-green">{0}</span> với trạng thái <span class="color-green">{1}</span>',
    NextMessage: 'KBĐT <span class="color-green">{0}</span> với trạng thái <span class="color-green">{1}</span>',
    PleaseCheck: '. Vui lòng kiểm tra lại.',
    TextButton: 'Đồng ý',
    Title: 'Không thể bỏ ghi',
  },

  UnpostedVoucherConfirmNoti: {
    Message:
      'Chứng từ <span class="color-green">{0}</span> đã được lập hồ sơ KBĐT <span class="color-green">{1}</span>, chương trình sẽ loại bỏ <span class="color-green">{2}</span> khỏi Hồ sơ KBĐT. Bạn có muốn bỏ ghi không?',
    PleaseCheck: '. Vui lòng kiểm tra lại.',
    TextButton: 'Đồng ý',
    Title: 'Bỏ ghi sổ chứng từ',
  },
  ScreenButton: {
    GenerateSalary: 'Sinh hạch toán lương, bảo hiểm',
  },
};
